import { z } from 'zod';

/** Zod schema for certificate configuration */
export const certConfigSchema = z.object({
  p12Path: z.string().min(1, 'P12_PATH is required'),
  p12Pass: z.string().min(1, 'P12_PASS is required'),
});

/** Zod schema for TAK server connection settings */
export const takServerConfigSchema = z.object({
  host: z.string().min(1),
  port: z.number().int().positive(),
  cert: certConfigSchema,
  streamPort: z.number().int().positive().optional(),
});

/** Zod schema for OpenAI configuration */
export const openAiConfigSchema = z.object({
  apiKey: z.string().min(1, 'OPENAI_API_KEY is required'),
  model: z.string().min(1),
});

/** Zod schema for Echo/Keycloak auth configuration */
export const echoAuthConfigSchema = z.object({
  keycloakUrl: z.string().url(),
  keycloakRealm: z.string().min(1),
  clientId: z.string().min(1),
  clientSecret: z.string().min(1),
  botUsername: z.string().min(1),
  botPassword: z.string().min(1),
});

/** Zod schema for the full application config */
export const appConfigSchema = z.object({
  port: z.number().int().positive().default(3000),
  takServer: takServerConfigSchema,
  googleMapsKey: z.string().optional(),
  echoApiUrl: z.string().url().optional(),
  echoAuth: echoAuthConfigSchema.optional(),
  echoLivekitWsUrl: z.string().url().optional(),
  databaseUrl: z.string().optional(),
  openAi: openAiConfigSchema.optional(),
  plugins: z.string().optional(),
  instanceRole: z.string().optional(),
  vertexApiUrl: z.string().url().optional(),
  vertexUnitId: z.string().optional(),
  orgSlug: z.string().optional(),
  instanceId: z.string().optional(),
  devMode: z.boolean().optional(),
  portFallback: z.boolean().optional(),
  mapProvider: z.string().optional(),
  aiProvider: z.string().optional(),
});
